module.exports = __webpack_public_path__ + "static/media/card-placeholder_min.e53bd399.svg";